exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tags-input-root{position:relative}", ""]);

// exports
